import { ViewStyle } from "react-native";

import { ClassGroupType } from "../../Style.types";

export interface IPositionClassGroup {
  relative: ViewStyle;
  absolute: ViewStyle;
  fixed: React.CSSProperties;
}
export const PositionClassGroup: ClassGroupType<IPositionClassGroup> = {
  relative: { position: "relative" },
  absolute: { position: "absolute" },
  fixed: { position: "fixed" },
};
